import { render, staticRenderFns } from "./waiting-calls.vue?vue&type=template&id=9a356c3a&"
import script from "./waiting-calls.vue?vue&type=script&lang=js&"
export * from "./waiting-calls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports